import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { TLanguageIDs, IGroupsOfMediaSettings } from 'types';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../../../customerFullInfoState/customerFullInfoContext';
import Carousel from './components/Carousel/Carousel';
import NormalDisplay from './components/NormalDisplay/NormalDisplay';
import style from './MediaGroup.module.scss';

interface IMediaGroup {
	data: IGroupsOfMediaSettings;
	languageId: TLanguageIDs;
}

const MediaGroup: React.FC<IMediaGroup> = ({ data, languageId }) => {
	const { selectedStyleGroup, selectedStyleLanguage } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const headingElement = useRef<null | HTMLDivElement>(null);

	useEffect(() => {
		if (selectedStyleGroup?.id === data.id && selectedStyleLanguage === languageId) {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedStyleGroup]);

	const displayType = () => {
		if (data.isMultipleItems) {
			return <Carousel group={data} languageId={languageId} selectedStyleLanguage={selectedStyleLanguage} />;
		}
		return <NormalDisplay group={data} languageId={languageId} />;
	};

	return (
		<div className={style.container} ref={headingElement}>
			<Text
				translationNameSpace="mediaSettings"
				translationKey={data.key}
				theme="secondary"
				size="l"
				weight="bold"
			/>
			{displayType()}
		</div>
	);
};

export default MediaGroup;
